import React, { useState, useEffect } from 'react';

function useDebounce(initialValue, delay) {
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        const timer = setTimeout(() => {
            setValue(initialValue);
        }, delay);

        return () => clearTimeout(timer);
    }, [initialValue, delay]);

    return value;
}

export default useDebounce